import { applyMiddleware, combineReducers, compose, createStore } from 'redux'
import { createLogger } from 'redux-logger' // eslint-disable-line import/no-extraneous-dependencies
import thunk from 'redux-thunk'
import { wtaMiddleware } from './analytics/index.ts'
import config from './config'
import gapi from './gapi'
import * as reducer from './reducer/index.ts'
import PusherClient from './util/pusher.ts'

export const prepareMiddleWare = ({
  editorBaseUrl,
  onUploadSuccess,
  authApiUrl,
  onAuthUpdate,
  wtaiUploadUrl,
  wtaiExpressUrl,
}) => {
  config.setEditorBaseUrl(editorBaseUrl)
  config.setOnUploadSuccess(onUploadSuccess)
  config.setWtaiExpressUrl(wtaiExpressUrl)
  config.setWtaiUploadUrl(wtaiUploadUrl)
  config.setAuthApiUrl(authApiUrl)
  config.setOnAuthUpdate(onAuthUpdate)

  const pusherClient = new PusherClient()

  const enhancers = [
    thunk.withExtraArgument({
      gapi,
      config,
      pusherClient,
    }),
    // Initialize wta middleware even if `initRSW` is false.
    // Events may still  be dispatched to a rsw client initialized by a host app.
    wtaMiddleware,
  ]

  if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test') {
    const logger = createLogger({ collapsed: true })
    enhancers.push(logger)
  }
  return enhancers
}

export const reducers = combineReducers(reducer)
const configureStore = initialState => {
  const {
    editorBaseUrl,
    onUploadSuccess,
    authApiUrl,
    onAuthUpdate,
    wtaiExpressUrl,
    wtaiUploadUrl,
    ...reduxProperties
  } = initialState

  const globalWindow = typeof window !== 'undefined'
  if (!globalWindow) {
    return createStore(reducers, reduxProperties)
  }

  const middleWare = prepareMiddleWare({
    editorBaseUrl,
    onUploadSuccess,
    authApiUrl,
    onAuthUpdate,
    wtaiExpressUrl,
    wtaiUploadUrl,
  })
  let composeEnhancers = compose

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-underscore-dangle
    if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
      // eslint-disable-next-line no-underscore-dangle
      composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    }
  }
  return createStore(reducers, reduxProperties, composeEnhancers(applyMiddleware(...middleWare)))
}

export default configureStore
